var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),(_vm.isAuthorized)?[_c('router-view')]:[_c('Unauthorized')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }